import getApi from '../../api'

export const deleteQuestionTemplate = (id: number) =>
  getApi().delete<void>(`/question_templates/${id}`)
